<div class="wiz-integration-group step-group">
    <div class="step-info step-left">
        {{stepNumber || ''}}
    </div>
    <div class="step-info step-right">
        <ng-content></ng-content>
    </div>
</div>
